import React, { Component } from "react";

export default class ExperienceImg extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <div className="experience-video-div">
        <video autoPlay muted loop controls>
          <source src="exp.mp4" type="video/mp4"/> 
        </video> 
      </div>

    );
  }
}
